import apiService from '../apiService';

const baseUrl = `${window._env_.CALLBACKS_API_DOMAIN}`;

const consentDirector = (data) => {
  const url = `${baseUrl}/v1/director-authorization/consent`;
  return apiService.post(url, data);
};

export { consentDirector };
